const select = async function() {
    if ( !document.querySelector(".wpcf7-select") ) return;

    try {
        const CustomSelect = await (await import('../utils/custom-select')).default;
        document.querySelectorAll(".wpcf7-select").forEach(select => {
            const customSelect = new CustomSelect(select, {
                label: "Inquiry type",
                value: "none",
                afterElement: '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="7" fill="none" viewBox="0 0 8 7"><path fill="#19333D" d="m0 0 4 7 4-7H0Z"/></svg>',
            })
        })
    } catch (e) {}
}

export const init = select;